import { AbstractComponentPropTypes } from '../../../cms/registries';
import { ImageDefination } from '../../types/common';

export interface BrightcoveVideo {
  videoId: string;
  poster: string;
  accountId?: string;
  playerId?: string;
}

export type VideoType = keyof typeof Video;

export enum Video {
  youtube = 'youtube',
  upload = 'upload',
  brightcove = 'brightcove',
}

interface VideoSectionProps extends AbstractComponentPropTypes {
  videoType: VideoType;
  videoUrl: string;
  title: string;
  brightcove?: BrightcoveVideo;
  images?: ImageDefination[];
  autoPlay?: boolean;
}

export default VideoSectionProps;
